'use strict';

const Key = require('common/domain/value/key');
const UserRepository = require('common/domain/repository/user');
const CommentReactionAction = require('communication/domain/comment-reaction/action');

class Factory {
    constructor(project) {
        this._project = project;
    }

    build(json) {
        return new Promise(resolve => {
            json._project = this._project;
            if (json.userKey) {
                const userKey = new Key(json.userKey);
                UserRepository.get(userKey.id).then(user => {
                    json.user = user;
                    resolve(new CommentReactionAction(json));
                });
            } else {
                resolve(new CommentReactionAction(json));
            }
        });
    }
}

module.exports = Factory;



// WEBPACK FOOTER //
// ./communication/domain/comment-reaction/action-factory.js